import { useRef, useEffect } from 'react';

const diferenciais = [
  {
    number: '01',
    icon: 'ri-focus-3-line',
    title: 'Estudo e implantação',
    description: 'Leitura do terreno, do programa e das condicionantes para orientar soluções coerentes em termos espaciais, formais e funcionais.',
  },
  {
    number: '02',
    icon: 'ri-stack-line',
    title: 'Desenvolvimento e compatibilização',
    description: 'Projeto desenvolvido em BIM, com coordenação entre arquitetura e disciplinas complementares ao longo do processo.',
  },
  {
    number: '03',
    icon: 'ri-shield-check-line',
    title: 'Viabilidade e aprovação',
    description: 'Análise dos parâmetros técnicos e normativos desde as etapas iniciais, com foco na viabilidade do projeto e no encaminhamento para aprovação.',
  },
  {
    number: '04',
    icon: 'ri-bar-chart-box-line',
    title: 'Produto imobiliário',
    description: 'Nos empreendimentos, o projeto considera implantação, custo, posicionamento e valor percebido, sem abrir mão da qualidade arquitetônica.',
  },
];

export default function Diferenciais() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('animate-in');
        });
      },
      { threshold: 0.1 }
    );
    const elements = sectionRef.current?.querySelectorAll('.reveal');
    elements?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#111111] py-28 md:py-36 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20 reveal opacity-0 translate-y-8 transition-all duration-700">
          <p className="text-[#A3B18A] font-['Montserrat'] text-xs tracking-[4px] uppercase mb-4">
            Como Trabalhamos
          </p>
          <h2 className="font-['Montserrat'] font-bold text-3xl md:text-4xl lg:text-[52px] text-white">
            Processos
          </h2>
          <div className="w-12 h-[2px] bg-[#A3B18A] mx-auto mt-6" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {diferenciais.map((item, i) => (
            <div
              key={item.number}
              className="reveal opacity-0 translate-y-8 transition-all duration-700 group relative"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Number background */}
              <span className="absolute -top-4 -left-2 font-['Montserrat'] font-bold text-[80px] text-[#A3B18A]/10 leading-none select-none pointer-events-none">
                {item.number}
              </span>

              {/* Content */}
              <div className="relative pt-8 pb-8 border-t border-[#2F2F2F] group-hover:border-[#A3B18A]/40 transition-colors duration-300">
                <div className="w-10 h-10 flex items-center justify-center mb-5">
                  <i className={`${item.icon} text-[#A3B18A] text-2xl`} />
                </div>
                <h3 className="font-['Montserrat'] font-bold text-lg text-white mb-4 leading-snug">
                  {item.title}
                </h3>
                <p className="font-['Montserrat'] text-[#EDEDED]/70 text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>

              {/* Separator (not on last in row) */}
              {i < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-[1px] h-24 bg-[#A3B18A]/15 -translate-y-1/2" />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
